import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { ObjectAddService } from '../Component(2D and 3D)/3D/ObjectAdd/object-add.service';
import { ProductsService } from '../services/products.service';
import { environment } from '../../environments/environment';
import { RailingColorsService } from '../services/railing/services/railing-colors.service';
import { map, filter } from 'rxjs/operators';
import { StageService } from '../services/stage.service';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { Subscription } from 'rxjs';
import { AwningColorTextureService } from '../services/awning/awning-color-texture.service';
import { AwningService } from '../services/awning/awning.service';

declare const THREE: any;

@Component({
  selector: 'app-add-awnings',
  templateUrl: './add-awnings.component.html',
  styleUrls: ['./add-awnings.component.scss']
})
export class AddAwningsComponent implements OnInit {
  @Output() step1Editer = new EventEmitter();
  selectedColor;
  colors: any = [];
  awnings: any[];
  selected: any = null;
  recentlySelectedDesign: any = null;
  apiUrl: string = environment.apiUrl;
  colorGroups: any;
  loader = new THREE.TextureLoader();
  textures;
  selectedGlassTexture;
  selectedFrameColor;
  updateTextureAndColorSubscription: Subscription;
  awningAddedSubscription: Subscription;

  constructor(
    private productsService: ProductsService,
    public colorsService: RailingColorsService,
    private objectAddService: ObjectAddService,
    private stage: StageService,
    private awningService: AwningService,
    private awningColorTextureService: AwningColorTextureService
  ) {}

  private _updateData() {
    this.updateTextureAndColorSubscription = combineLatest(
      this.awningColorTextureService.selectedFrameColor,
      this.awningColorTextureService.selectedGlassTexture,
      this.awningColorTextureService.colors
    )
      .pipe(
        map(([color, texture, colors]) => {
          this.selectedFrameColor = color;
          this.selectedGlassTexture = texture;
          this.colors = colors;
        })
      )
      .subscribe();
  }

  private _onAwningAdded() {
    this.awningAddedSubscription = this.stage.objectAdded
      .pipe(
        filter(obj => obj.name === 'Awning'),
        map(obj => {
          this.selected = null;
          if (this.awningService.isBaseAwning(obj))
            this.recentlySelectedDesign = obj.userData.entity.awningType;
        })
      )
      .subscribe();
  }

  async ngOnInit() {
    this.textures = this.awningColorTextureService.textures;
    this._updateData();
    this.awnings = await this.productsService.getBaseAwnings();
    this._onAwningAdded();
  }

  itemClick(item): void {
    this.selected = item;
    this.objectAddService.setEntity(item);
  }

  remove() {
    this.objectAddService.remove();
  }

  goBack(value) {
    this.step1Editer.emit({ name: value });
  }

  onColorChange(color) {
    this.awningColorTextureService.setFrameColor(color);
  }

  onTextureChange(texture) {
    this.awningColorTextureService.setGlassTexture(texture);
  }

  ngOnDestroy() {
    if (this.updateTextureAndColorSubscription)
      this.updateTextureAndColorSubscription.unsubscribe();
    if (this.awningAddedSubscription) this.awningAddedSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/add-awnings/add-awnings.component.ts